import React from 'react';
import { ReactSVG } from 'react-svg';
import Svg from 'assets/images/payment/visa.svg';

type Props = {
  className?: string;
};

export const VisaIcon = ({ className }: Props) => {
  return (
    <ReactSVG
      src={Svg}
      className={className}
    />
  );
};
